import { NgModule, ModuleWithProviders } from '@angular/core';
import { ToastrModule, GlobalConfig, IndividualConfig, TOAST_CONFIG, DefaultGlobalConfig } from 'ngx-toastr';
import { FnToasterService } from './fn-toaster';


export { FnToasterService } from './fn-toaster';
/**
 * FnToasterGlobalConfig interface for Configuration of an individual toast.
 */
export interface FnToasterGlobalConfig extends GlobalConfig { };
/**
 * FnToasterIndividualConfig interface for Configuration global configuration and of all individual toast.
 */
export interface FnToasterIndividualConfig extends IndividualConfig { };

/** 
 * Provide the required FnToasterService to create notification popups of different types.
 * making them available for import by NgModules that import this module.
 */

@NgModule({
    imports: [
        ToastrModule
    ],
    providers: [FnToasterService]
})
export class FnToasterModule {
    static forRoot(config: Partial<GlobalConfig> = {}): ModuleWithProviders<FnToasterModule> {
        return {
            ngModule: FnToasterModule,
            providers: [
                FnToasterService,
                {
                    provide: TOAST_CONFIG,
                    useValue: {
                        default: DefaultGlobalConfig,
                        config
                    }
                }
            ]
        }
    }
}